import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styled from 'styled-components';
import { Submit } from "src/components/atoms/Buttons";

import * as Typos from 'src/components/atoms/Typographs';
import { Status } from "src/config";
import routes from "src/constants/routes";
import friendService from 'src/services/friend.service';
import { FOLLOW_BUTTON } from "src/theme/Labels";
import Errors from "src/theme/Errors";

const FolloweeCell = props => {
  const [ avatar, setAvatar ] = useState('');
  const [ username, setUsername ] = useState('');
  const [ avatarname, setAvatarname] = useState('');
  const [ id ] = useState(props.user?._id);
  const [ followingStatus, setFollowingStatus ] = useState(Status.NONE);
  
  useEffect(() => {
    const image = props.user?.avatar;
    const names = [];
    const avatarnames = [];
    if (props.user?.firstname) {
      names.push(props.user?.firstname);
      avatarnames.push(props.user?.firstname[0]);
    }
    if (props.user?.lastname) {
      names.push(props.user?.lastname);
      avatarnames.push(props.user?.lastname[0]);
    }
    setAvatarname(avatarnames.join(''));
    setAvatar(image);
    setUsername(names.join(' '));
  }, []);

  const followUser = () => {
    setFollowingStatus(Status.REQUEST);
    friendService
      .follow(id)
      .then(() => {
        setFollowingStatus(Status.SUCCESS);
        props.onFollowSuccess && props.onFollowSuccess(false);
      })
      .catch((err) => {
        if (err === Errors.ALREADY_FRIEND) {
          props.onFollowSuccess && props.onFollowSuccess(true);
          setFollowingStatus(Status.SUCCESS);
        } else {
          setFollowingStatus(Status.FAILURE);
        }
      });
  };

  return (
    <UserItem style={props.style}>
      <Link className="image-wrapper" to={routes.ALL_USERS + '/' + props.user?.username}>
        {
          avatar ? <img src={avatar} alt="usernmae" /> : <div className="name-avatar"><div className="name">{avatarname}</div></div>
        }
      </Link>
      <Typos.H7 lines={1} className={"d-block mb-2" + (props.listPage ? ' mt-2' : ' mt-1')} as={Link} to={routes.ALL_USERS + '/' + props.user?.username}>{username}</Typos.H7>
      <Submit theme={props.buttonTheme || "outline"} title={FOLLOW_BUTTON} status={followingStatus} onClick={followUser} />
    </UserItem>
  )
};

const UserItem = styled.div`
  width: 80px;
  margin: auto;
  text-align: center;

  .image-wrapper {
    width: 100%;
    height: 0px;
    padding-top: 100%;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    display: block;

    img {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .name-avatar {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      background-color: black;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;

      .name {        
        font-size: 48px;
        line-height: 80px;
        font-family: 'Futura LT light';
      }
    }
  }

  button {
    width: unset;
    min-width: 80px;
    height: 28px;
    margin: auto;
  }
`;

export default FolloweeCell;